import axios from 'axios';
const url = 'https://api.app-lab.be-keeper.com/tags';
// const url = `${process.env.API}/tags`;

//Tags routes
export const fetchTags = () => axios.get(url);
export const createTags = (newTag) => axios.post(url, newTag);
export const updateTag = (id, updatedTag) => axios.patch(`${url}/${id}`, updatedTag);
export const deleteTag = (id) => axios.delete(`${url}/${id}`);